var wipwrp = window.wipwrp || {};

wipwrp.listaNera = (function($,mzr,doc,win) {

    var self = {};
    var popup = $('#lista-nera-form').get(0);
    var ctas = $('[data-lista-nera-cta]');

    self.init = function () {
        _bindListaNeraModal();
    }

    _bindListaNeraModal = function () {
        if (ctas.length) {
            ctas.on('click', (e) => {
                e.preventDefault();

                const clone = popup.cloneNode(true);
                clone.style.display = '';

                vex.dialog.alert({
                    unsafeMessage: clone,
                    showCloseButton:true,
                    overlayClosesOnClick:false,
                    buttons: [],
                })
            })
        }
    }

    return self;
})(jQuery,Modernizr, document, window);